import React from "react";
import styles from "./ui.module.css";

export const Stack = ({ className = "", children }) => {
  return <div className={`${styles.stack} ${className}`}>{children}</div>;
};